import React from "react";
import { useTranslation } from "react-i18next";

const Step4DesignService = ({ answers, updateAnswers }) => {
  const { t } = useTranslation();

  const handleSelect = (value) => {
    updateAnswers({
      wantsDesignService: value,
      designServiceNotes: value ? answers.designServiceNotes || "" : "",
    });
  };

  const handleNotesChange = (event) => {
    updateAnswers({ designServiceNotes: event.target.value });
  };

  return (
    <div className="onboarding-step onboarding-step--design">
      <h2 className="onboarding-step__title">
        {t("homeModalWelcome.step4.title")}
      </h2>
      <p className="onboarding-step__description">
        {t("homeModalWelcome.step4.description")}
      </p>

      <div className="onboarding-radio-cards">
        <button
          type="button"
          className={`onboarding-radio-card ${
            answers.wantsDesignService === true ? "is-selected" : ""
          }`}
          onClick={() => handleSelect(true)}
        >
          <span className="onboarding-radio-card__title">
            {t("homeModalWelcome.step4.optionYes")}
          </span>
          <span className="onboarding-radio-card__description">
            {t("homeModalWelcome.step4.optionYesDesc")}
          </span>
        </button>
        <button
          type="button"
          className={`onboarding-radio-card ${
            answers.wantsDesignService === false ? "is-selected" : ""
          }`}
          onClick={() => handleSelect(false)}
        >
          <span className="onboarding-radio-card__title">
            {t("homeModalWelcome.step4.optionNo")}
          </span>
          <span className="onboarding-radio-card__description">
            {t("homeModalWelcome.step4.optionNoDesc")}
          </span>
        </button>
      </div>

      {answers.wantsDesignService === true && (
        <div className="onboarding-step__notes">
          <label
            htmlFor="design-notes"
            className="onboarding-step__label"
          >
            {t("homeModalWelcome.step4.notesLabel")}
          </label>
          <textarea
            id="design-notes"
            className="onboarding-textarea"
            rows={3}
            value={answers.designServiceNotes || ""}
            onChange={handleNotesChange}
            placeholder={t("homeModalWelcome.step4.notesPlaceholder")}
          />
        </div>
      )}
    </div>
  );
};

Step4DesignService.canAdvance = (answers) => answers.wantsDesignService === true || answers.wantsDesignService === false;

export default Step4DesignService;
